'use client';

import { createImageBuilder } from '@lib/sanity/imageBuilder';
import { useClientConfig } from '@providers/ClientConfigProvider';
import { useMemo } from 'react';
import { renderVisualsImage, type VisualsImageProps } from './renderVisualsImage';

/**
 * Client-only version (safe to use from client components).
 * For server components, use `@ui/Visuals/VisualsImage` instead.
 */
export default function VisualsImageClient({
  image,
  isEagerLoad,
  loading,
  className,
  style,
  sizes,
  showPlaceholderImage,
}: VisualsImageProps) {
  const config = useClientConfig();
  const builder = useMemo(() => {
    return createImageBuilder(config.SANITY_PROJECT_ID, config.SANITY_DATASET);
  }, [config.SANITY_PROJECT_ID, config.SANITY_DATASET]);

  return renderVisualsImage(builder, {
    image,
    isEagerLoad,
    loading,
    className,
    style,
    sizes,
    showPlaceholderImage,
  });
}
